// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BackgroundPicture-module-wrapper","picture":"BackgroundPicture-module-picture"};